// Constants
import {
  APP_TRACKING_CONFIGURATION_PAGENAME,
  TRACKING_CONFIGURATION,
} from '../constants/app.tracking.hook.constants';
// Enumerations
import { RoutesEnumeration } from 'enumerations/routes.enumeration';
//  Types
import { GetTrackingInstanceType } from 'tracking/types/get-tracking-instance.type';

const getTrackingIdAccordingConfiguredView = (pathname: string): string =>
  ({
    [RoutesEnumeration.ACTIVATE]: APP_TRACKING_CONFIGURATION_PAGENAME.ACTIVATE,
    [RoutesEnumeration.CARD_SETTINGS]: APP_TRACKING_CONFIGURATION_PAGENAME.CARD_SETTINGS,
    [RoutesEnumeration.DASHBOARD]: APP_TRACKING_CONFIGURATION_PAGENAME.DASHBOARD,
    [RoutesEnumeration.FINANCING]: APP_TRACKING_CONFIGURATION_PAGENAME.FINANCING,
    [RoutesEnumeration.POINTS]: APP_TRACKING_CONFIGURATION_PAGENAME.POINTS,
    [RoutesEnumeration.REPORT_A_PROBLEM]: APP_TRACKING_CONFIGURATION_PAGENAME.REPORT_A_PROBLEM,
    [RoutesEnumeration.SUPPORT]: APP_TRACKING_CONFIGURATION_PAGENAME.SUPPORT,
    [RoutesEnumeration.TRANSACTIONS]: APP_TRACKING_CONFIGURATION_PAGENAME.TRANSACTIONS,
  }[pathname] ?? '');

const getTrackingConfiguration = (userId: string): GetTrackingInstanceType => ({
  ...TRACKING_CONFIGURATION,
  userId: userId ?? '',
});

export { getTrackingConfiguration, getTrackingIdAccordingConfiguredView };
